import { render, staticRenderFns } from "./ProductReward.vue?vue&type=template&id=690e8e08&"
import script from "./ProductReward.vue?vue&type=script&lang=js&"
export * from "./ProductReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports